export default {"src":"/_next/static/media/ship-skis-text-only.d9a0ac65.svg","height":13,"width":54,"blurWidth":0,"blurHeight":0};